import { isLocalEnvironment } from "@lib/environment";
import { authApiClient } from "@features/auth/auth-api-client";

export type AuthLogoutDeps = {
  logout: () => Promise<Response>;
  removeAccessToken: () => Promise<void>;
};

export type AuthLogoutOptions = {
  remoteAuthEnabled: boolean;
};

export const defaultAuthLogoutDeps: AuthLogoutDeps = {
  logout: authApiClient.logout,
  removeAccessToken: async () => {
    const { removeAccessTokenFromCookies } = await import("@features/auth/utils/utils-server");

    return removeAccessTokenFromCookies();
  },
};

const ignoreRejection = async (effect: () => Promise<unknown>) => {
  try {
    await effect();
  } catch {
    // Logout must still complete locally when remote logout or cookie mutation fails.
  }
};

export const resolveAuthLogout = async (
  deps: AuthLogoutDeps = defaultAuthLogoutDeps,
  options: AuthLogoutOptions = { remoteAuthEnabled: !isLocalEnvironment },
) => {
  if (options.remoteAuthEnabled) {
    await ignoreRejection(deps.logout);
  }

  await ignoreRejection(deps.removeAccessToken);
};
